module.exports = __webpack_public_path__ + "static/img/memeber_gift_btn.52971543.png";